let lsOrgFile = {
  itSecurityPackage: [],
  dataProtectionPolicy: [],
  latestCsrReport: [],
  professionalIndemnityInsurance: [],
  diversityPolicy: [],
  conflictCheckPolicy: [],
  esgPolicy: [],
  businessEngagementTc: [],
  reportToThirdParty: []
};

let cuSignUpFile = {
  logo: null
};

let lsTermsChecked = false;

let proposalLeadPartner = [
  {
    photo: [],
    biography: []
  }
];

let proposalVideo = [
  {
    upload_video: []
  }
];

export const initialRfpFile = {
  conflictCheckDescriptionFile: [],
  preliminaryInfoDescriptionFile: [],
  termsConditionsFile: [],
  scopeOtherFile: [],
  scopeCommercialFile: [],
  scopeCompetitionFile: [],
  scopeCorporateFile: [],
  scopeDataProtectionFile: [],
  scopeEmploymentFile: [],
  scopeFinancingFile: [],
  scopeProjectsFile: [],
  scopeFundFormationFile: [],
  scopeFundInvestmentFile: [],
  scopeIpFile: [],
  scopeItFile: [],
  scopeInsolvencyFile: [],
  scopeArbitrationFile: [],
  scopeLitigationFile: [],
  scopeRegulatoryFile: [],
  scopeRestructuringFile: [],
  scopeTaxFile: []
};

let rfpFile = {
  conflictCheckDescriptionFile: [],
  preliminaryInfoDescriptionFile: [],
  termsConditionsFile: [],
  scopeOtherFile: [],
  scopeCommercialFile: [],
  scopeCompetitionFile: [],
  scopeCorporateFile: [],
  scopeDataProtectionFile: [],
  scopeEmploymentFile: [],
  scopeFinancingFile: [],
  scopeProjectsFile: [],
  scopeFundFormationFile: [],
  scopeFundInvestmentFile: [],
  scopeIpFile: [],
  scopeItFile: [],
  scopeInsolvencyFile: [],
  scopeArbitrationFile: [],
  scopeLitigationFile: [],
  scopeRegulatoryFile: [],
  scopeRestructuringFile: [],
  scopeTaxFile: [],
  preliminaryAdditionalDocRemoveFile: [],
  preliminaryTermsDocRemoveFile: [],
  scopeAdditionalDocRemoveFile: [],
  scopeOtherRemoveFile: [],
  scopeCommercialRemoveFile: [],
  scopeCompetitionRemoveFile: [],
  scopeCorporateRemoveFile: [],
  scopeDataProtectionRemoveFile: [],
  scopeEmploymentRemoveFile: [],
  scopeFinancingRemoveFile: [],
  scopeProjectsRemoveFile: [],
  scopeFundFormationRemoveFile: [],
  scopeFundInvestmentRemoveFile: [],
  scopeIpRemoveFile: [],
  scopeItRemoveFile: [],
  scopeInsolvencyRemoveFile: [],
  scopeArbitrationRemoveFile: [],
  scopeLitigationRemoveFile: [],
  scopeRegulatoryRemoveFile: [],
  scopeRestructuringRemoveFile: [],
  scopeTaxRemoveFile: [],
  pricingAdditionalDocRemoveFile: [],
  conflictAdditionalDocRemoveFile: [],
  otherKeyAdditionalDocRemoveFile: []
};

let proposalFile = {
  preliminaryAdditionalDocumentFile: [],
  pricingAdditionalDocumentFile: [],
  OtherKeyInfoAdditionalDocumentFile: [],
  scopeOfWorkAdditionalDocumentFile: [],
  preliminaryAdditionalDocRemoveFile: [],
  scopeAdditionalDocRemoveFile: [],
  pricingAdditionalDocRemoveFile: [],
  otherKeyAdditionalDocRemoveFile: [],
  leadPartnerMemberRemoveFile: [],
  videoRemoveFile: []
};

export const putRfpSaveFile = (obj) => {
  rfpFile = obj;
};

export const getRfpSaveFile = () => {
  return rfpFile;
};

export const getProposalSaveFile = () => {
  return proposalFile;
};

export const putProposalSaveFile = (obj) => {
  proposalFile = obj;
};

export const resetRfpSaveFile = () => {
  rfpFile = {
    conflictCheckDescriptionFile: [],
    preliminaryInfoDescriptionFile: [],
    termsConditionsFile: [],
    scopeOtherFile: [],
    scopeCommercialFile: [],
    scopeCompetitionFile: [],
    scopeCorporateFile: [],
    scopeDataProtectionFile: [],
    scopeEmploymentFile: [],
    scopeFinancingFile: [],
    scopeProjectsFile: [],
    scopeFundFormationFile: [],
    scopeFundInvestmentFile: [],
    scopeIpFile: [],
    scopeItFile: [],
    scopeInsolvencyFile: [],
    scopeArbitrationFile: [],
    scopeLitigationFile: [],
    scopeRegulatoryFile: [],
    scopeRestructuringFile: [],
    scopeTaxFile: [],
    preliminaryAdditionalDocRemoveFile: [],
    preliminaryTermsDocRemoveFile: [],
    scopeAdditionalDocRemoveFile: [],
    scopeOtherRemoveFile: [],
    scopeCommercialRemoveFile: [],
    scopeCompetitionRemoveFile: [],
    scopeCorporateRemoveFile: [],
    scopeDataProtectionRemoveFile: [],
    scopeEmploymentRemoveFile: [],
    scopeFinancingRemoveFile: [],
    scopeProjectsRemoveFile: [],
    scopeFundFormationRemoveFile: [],
    scopeFundInvestmentRemoveFile: [],
    scopeIpRemoveFile: [],
    scopeItRemoveFile: [],
    scopeInsolvencyRemoveFile: [],
    scopeArbitrationRemoveFile: [],
    scopeLitigationRemoveFile: [],
    scopeRegulatoryRemoveFile: [],
    scopeRestructuringRemoveFile: [],
    scopeTaxRemoveFile: [],
    pricingAdditionalDocRemoveFile: [],
    conflictAdditionalDocRemoveFile: [],
    otherKeyAdditionalDocRemoveFile: []
  };
};

export const resetProposalSaveFile = () => {
  proposalFile = {
    preliminaryAdditionalDocumentFile: [],
    pricingAdditionalDocumentFile: [],
    OtherKeyInfoAdditionalDocumentFile: [],
    scopeOfWorkAdditionalDocumentFile: [],
    preliminaryAdditionalDocRemoveFile: [],
    scopeAdditionalDocRemoveFile: [],
    pricingAdditionalDocRemoveFile: [],
    otherKeyAdditionalDocRemoveFile: [],
    leadPartnerMemberRemoveFile: [],
    videoRemoveFile: []
  };
};

export const getEmptyProposalFile = () => {
  return {
    preliminaryAdditionalDocumentFile: [],
    pricingAdditionalDocumentFile: [],
    OtherKeyInfoAdditionalDocumentFile: [],
    scopeOfWorkAdditionalDocumentFile: [],
    preliminaryAdditionalDocRemoveFile: [],
    scopeAdditionalDocRemoveFile: [],
    pricingAdditionalDocRemoveFile: [],
    otherKeyAdditionalDocRemoveFile: [],
    leadPartnerMemberRemoveFile: [],
    videoRemoveFile: []
  };
};

export const getUploadedProposalFile = () => {
  return {
    preliminaryAdditionalDocumentFile: [],
    pricingAdditionalDocumentFile: [],
    OtherKeyInfoAdditionalDocumentFile: [],
    scopeOfWorkAdditionalDocumentFile: [],
    preliminaryAdditionalDocRemoveFile: [],
    scopeAdditionalDocRemoveFile: [],
    pricingAdditionalDocRemoveFile: [],
    otherKeyAdditionalDocRemoveFile: [],
    leadPartnerMemberRemoveFile: [],
    videoRemoveFile: []
  };
};

export const getEmptyRfpFile = () => {
  return {
    conflictCheckDescriptionFile: [],
    preliminaryInfoDescriptionFile: [],
    termsConditionsFile: [],
    scopeOtherFile: [],
    scopeCommercialFile: [],
    scopeCompetitionFile: [],
    scopeCorporateFile: [],
    scopeDataProtectionFile: [],
    scopeEmploymentFile: [],
    scopeFinancingFile: [],
    scopeProjectsFile: [],
    scopeFundFormationFile: [],
    scopeFundInvestmentFile: [],
    scopeIpFile: [],
    scopeItFile: [],
    scopeInsolvencyFile: [],
    scopeArbitrationFile: [],
    scopeLitigationFile: [],
    scopeRegulatoryFile: [],
    scopeRestructuringFile: [],
    scopeTaxFile: [],
    preliminaryAdditionalDocRemoveFile: [],
    preliminaryTermsDocRemoveFile: [],
    scopeAdditionalDocRemoveFile: [],
    scopeOtherRemoveFile: [],
    scopeCommercialRemoveFile: [],
    scopeCompetitionRemoveFile: [],
    scopeCorporateRemoveFile: [],
    scopeDataProtectionRemoveFile: [],
    scopeEmploymentRemoveFile: [],
    scopeFinancingRemoveFile: [],
    scopeProjectsRemoveFile: [],
    scopeFundFormationRemoveFile: [],
    scopeFundInvestmentRemoveFile: [],
    scopeIpRemoveFile: [],
    scopeItRemoveFile: [],
    scopeInsolvencyRemoveFile: [],
    scopeArbitrationRemoveFile: [],
    scopeLitigationRemoveFile: [],
    scopeRegulatoryRemoveFile: [],
    scopeRestructuringRemoveFile: [],
    scopeTaxRemoveFile: [],
    pricingAdditionalDocRemoveFile: [],
    conflictAdditionalDocRemoveFile: [],
    otherKeyAdditionalDocRemoveFile: []
  };
};

export const putLsSaveFile = (obj) => {
  lsOrgFile = obj;
};

export const getLsSaveFile = () => {
  return lsOrgFile;
};

export const resetLsSaveFile = () => {
  lsOrgFile = {
    itSecurityPackage: [],
    dataProtectionPolicy: [],
    latestCsrReport: [],
    professionalIndemnityInsurance: [],
    diversityPolicy: [],
    conflictCheckPolicy: [],
    esgPolicy: [],
    businessEngagementTc: [],
    reportToThirdParty: []
  };
};

export const LspSignupRemoveFileArray = [
  'itSecurityPackage',
  'dataProtectionPolicy',
  'latestCsrReport',
  'professionalIndemnityInsurance',
  'diversityPolicy',
  'conflictCheckPolicy',
  'esgPolicy',
  'businessEngagementTc',
  'reportToThirdParty'
];
let LSFileOrg = [];

export const getLsFileOrg = () => {
  return LSFileOrg;
};
export const resetLsFileOrg = () => {
  LSFileOrg = [];
};

export const deleteLSFileOrg = (data) => {
  LSFileOrg.push(data);
};

export const getCuSignUpFile = () => {
  return cuSignUpFile;
};
export const putCuSignUpLogoFile = (obj) => {
  cuSignUpFile.logo = obj;
};

export const putLsTermsChecked = (value) => {
  lsTermsChecked = value;
};

export const getLsTermsChecked = () => {
  return lsTermsChecked;
};

export const getProposalLeadPartner = () => {
  return proposalLeadPartner;
};

export const putProposalLeadPartner = (obj) => {
  proposalLeadPartner = obj;
};

export const addNewProposalLeadPartner = () => {
  proposalLeadPartner.push({
    photo: [],
    biography: []
  });
};

export const getProposalVideo = () => {
  return proposalVideo;
};

export const putProposalVideo = (obj) => {
  proposalVideo = obj;
};

let deleteFile = [];
export const deleteLSOrgFile = (file) => {
  deleteFile = file;
  return deleteFile;
};

export const removeFileArray = [
  'conflictAdditionalDocRemoveFile',
  'preliminaryAdditionalDocRemoveFile',
  'preliminaryTermsDocRemoveFile',
  'scopeOtherRemoveFile',
  'scopeCommercialRemoveFile',
  'scopeCompetitionRemoveFile',
  'scopeCorporateRemoveFile',
  'scopeDataProtectionRemoveFile',
  'scopeEmploymentRemoveFile',
  'scopeFinancingRemoveFile',
  'scopeProjectsRemoveFile',
  'scopeFundFormationRemoveFile',
  'scopeFundInvestmentRemoveFile',
  'scopeIpRemoveFile',
  'scopeItRemoveFile',
  'scopeInsolvencyRemoveFile',
  'scopeArbitrationRemoveFile',
  'scopeLitigationRemoveFile',
  'scopeRegulatoryRemoveFile',
  'scopeRestructuringRemoveFile',
  'scopeTaxRemoveFile'
];

export const rfpErrorFileArray = [
  'conflictCheckDescriptionFile',
  'preliminaryInfoDescriptionFile',
  'termsConditionsFile',
  'scopeOtherFile',
  'scopeCommercialFile',
  'scopeCompetitionFile',
  'scopeCorporateFile',
  'scopeDataProtectionFile',
  'scopeEmploymentFile',
  'scopeFinancingFile',
  'scopeProjectsFile',
  'scopeFundFormationFile',
  'scopeFundInvestmentFile',
  'scopeIpFile',
  'scopeItFile',
  'scopeInsolvencyFile',
  'scopeArbitrationFile',
  'scopeLitigationFile',
  'scopeRegulatoryFile',
  'scopeRestructuringFile',
  'scopeTaxFile'
];

export const proposalRemoveFileArray = [
  'preliminaryAdditionalDocRemoveFile',
  'scopeAdditionalDocRemoveFile',
  'pricingAdditionalDocRemoveFile',
  'otherKeyAdditionalDocRemoveFile',
  'leadPartnerMemberRemoveFile',
  'videoRemoveFile'
];

export const fileLimitValidation = (existingFiles, newFiles, maxLimit = 5) => {
  const existingCount = existingFiles?.length || 0;
  const newCount = newFiles?.length || 0;
  return existingCount + newCount > maxLimit;
};

export const validateFileUploadsForProposal = (values, proposalFileUploads, uploadFiles, step, onHandleStepChange, sendNotification) => {
  const updatedFormValue = { ...values };
  const fileArrays = {
    preliminaryInfoAdditionalFile: [...(updatedFormValue.preliminary_info?.[0]?.additional_docs || [])],
    scopeOfWorkAdditionalFile: [...(updatedFormValue.scope_of_work?.[0]?.additional_docs || [])],
    pricingAdditionalFile: [...(updatedFormValue.pricing?.[0]?.additional_docs || [])],
    otherKeyInfoAdditionalFile: [...(updatedFormValue.other_key_info?.[0]?.additional_docs || [])],
    videoFile: [...(updatedFormValue.other_key_info?.[0]?.video?.upload_video?.file || [])]
  };

  let leadPartnerMemberFile = [];
  updatedFormValue.other_key_info[0].key_team_members.lead_partner_member.forEach((item) => {
    leadPartnerMemberFile.push(item.add_biography.file || []);
  });

  const fileUploadsMapping = {
    preliminaryInfoAdditionalFile: proposalFileUploads.preliminaryAdditionalDocumentFile || [],
    scopeOfWorkAdditionalFile: proposalFileUploads.scopeOfWorkAdditionalDocumentFile || [],
    pricingAdditionalFile: proposalFileUploads.pricingAdditionalDocumentFile || [],
    otherKeyInfoAdditionalFile: proposalFileUploads.OtherKeyInfoAdditionalDocumentFile || [],
    videoFile: uploadFiles.videoFile || [],
    leadPartnerMemberFile: uploadFiles.leadPartnerMemberFile?.flat() || []
  };

  const stepMapping = {
    preliminaryInfoAdditionalFile: '/legal-service/proposals/preliminaryinformation',
    scopeOfWorkAdditionalFile: '/legal-service/proposals/scopeofwork',
    pricingAdditionalFile: '/legal-service/proposals/pricing',
    otherKeyInfoAdditionalFile: '/legal-service/proposals/OtherKeyInformation',
    videoFile: '/legal-service/proposals/OtherKeyInformation',
    leadPartnerMemberFile: '/legal-service/proposals/OtherKeyInformation'
  };

  for (const key of Object.keys(fileArrays)) {
    const files = fileUploadsMapping[key];
    const originalFiles = fileArrays[key] || [];
    const isLimitExceeded = fileLimitValidation(originalFiles, files, 5);

    if (isLimitExceeded) {
      sendNotification({ message: 'You can only upload a maximum of 5 files', variant: 'error' });
      const stepUrl = stepMapping[key] || '/legal-service/proposals';
      onHandleStepChange(step, stepUrl, true);
      return false;
    }
  }
  return true;
};

export const sowParentMapping = {
  commercial_contracts: 'scopeCommercialRemoveFile',
  competition: 'scopeCompetitionRemoveFile',
  corporate_ma: 'scopeCorporateRemoveFile',
  data_protection_privacy: 'scopeDataProtectionRemoveFile',
  employment: 'scopeEmploymentRemoveFile',
  financing_capital_markets: 'scopeFinancingRemoveFile',
  infrastructure_projects_financing: 'scopeProjectsRemoveFile',
  fund_formation: 'scopeFundFormationRemoveFile',
  fund_investment: 'scopeFundInvestmentRemoveFile',
  ip: 'scopeIpRemoveFile',
  it: 'scopeItRemoveFile',
  insolvency: 'scopeInsolvencyRemoveFile',
  litigation: 'scopeLitigationRemoveFile',
  arbitration: 'scopeArbitrationRemoveFile',
  restructuring: 'scopeRestructuringRemoveFile',
  regulatory: 'scopeRegulatoryRemoveFile',
  tax: 'scopeTaxRemoveFile',
  other: 'scopeOtherRemoveFile'
};

export const validateFileUploads = (values, uploadFiles, onHandleStepChange, sendNotification) => {
  const updatedFormValue = { ...values };
  const conflictCheckDescriptionFile = [...(updatedFormValue.conflict_check?.[0]?.description_file?.[0]?.file || [])];
  const preliminaryInfoDescriptionFile = [...(updatedFormValue.preliminary_info?.[0]?.description_file?.[0]?.file || [])];
  const termsConditionsFile = [
    ...(updatedFormValue.preliminary_info?.[0]?.terms_conditions?.not_pre_agreed?.our_terms_condition?.terms_conditions_file?.file || [])
  ];
  const scopeOtherFile = [...(updatedFormValue.scope_of_work?.[0]?.other?.description_file?.[0]?.file || [])];
  const scopeCommercialFile = [...(updatedFormValue.scope_of_work?.[0]?.commercial_contracts?.file || [])];
  const scopeCompetitionFile = [...(updatedFormValue.scope_of_work?.[0]?.competition?.file || [])];
  const scopeCorporateFile = [...(updatedFormValue.scope_of_work?.[0]?.corporate_ma?.file || [])];
  const scopeDataProtectionFile = [...(updatedFormValue.scope_of_work?.[0]?.data_protection_privacy?.file || [])];
  const scopeEmploymentFile = [...(updatedFormValue.scope_of_work?.[0]?.employment?.file || [])];
  const scopeFinancingFile = [...(updatedFormValue.scope_of_work?.[0]?.financing_capital_markets?.file || [])];
  const scopeProjectsFile = [...(updatedFormValue.scope_of_work?.[0]?.infrastructure_projects_financing?.file || [])];
  const scopeFundFormationFile = [...(updatedFormValue.scope_of_work?.[0]?.fund_formation?.file || [])];
  const scopeFundInvestmentFile = [...(updatedFormValue.scope_of_work?.[0]?.fund_investment?.file || [])];
  const scopeIpFile = [...(updatedFormValue.scope_of_work?.[0]?.ip?.file || [])];
  const scopeItFile = [...(updatedFormValue.scope_of_work?.[0]?.it?.file || [])];
  const scopeInsolvencyFile = [...(updatedFormValue.scope_of_work?.[0]?.insolvency?.file || [])];
  const scopeArbitrationFile = [...(updatedFormValue.scope_of_work?.[0]?.arbitration?.file || [])];
  const scopeLitigationFile = [...(updatedFormValue.scope_of_work?.[0]?.litigation?.file || [])];
  const scopeRegulatoryFile = [...(updatedFormValue.scope_of_work?.[0]?.regulatory?.file || [])];
  const scopeRestructuringFile = [...(updatedFormValue.scope_of_work?.[0]?.restructuring?.file || [])];
  const scopeTaxFile = [...(updatedFormValue.scope_of_work?.[0]?.tax?.file || [])];

  for (const key of rfpErrorFileArray) {
    const files = uploadFiles?.[key];
    let originalFiles = [];
    const fileMapping = {
      conflictCheckDescriptionFile: conflictCheckDescriptionFile,
      preliminaryInfoDescriptionFile: preliminaryInfoDescriptionFile,
      termsConditionsFile: termsConditionsFile,
      scopeOtherFile: scopeOtherFile,
      scopeCommercialFile: scopeCommercialFile,
      scopeCompetitionFile: scopeCompetitionFile,
      scopeCorporateFile: scopeCorporateFile,
      scopeDataProtectionFile: scopeDataProtectionFile,
      scopeEmploymentFile: scopeEmploymentFile,
      scopeFinancingFile: scopeFinancingFile,
      scopeProjectsFile: scopeProjectsFile,
      scopeFundFormationFile: scopeFundFormationFile,
      scopeFundInvestmentFile: scopeFundInvestmentFile,
      scopeIpFile: scopeIpFile,
      scopeItFile: scopeItFile,
      scopeInsolvencyFile: scopeInsolvencyFile,
      scopeArbitrationFile: scopeArbitrationFile,
      scopeLitigationFile: scopeLitigationFile,
      scopeRegulatoryFile: scopeRegulatoryFile,
      scopeRestructuringFile: scopeRestructuringFile,
      scopeTaxFile: scopeTaxFile
    };
    originalFiles = (fileMapping && fileMapping[key]) || [];
    const isLimitExceeded = fileLimitValidation(originalFiles, files, 5);
    if (isLimitExceeded) {
      sendNotification({ message: `You can only upload a maximum of 5 files`, variant: 'error' });
      if (key === 'conflictCheckDescriptionFile') {
        onHandleStepChange(0, '/corporate/rfp/create/conflict', true);
      } else if (key === 'preliminaryInfoDescriptionFile' || key === 'termsConditionsFile') {
        onHandleStepChange(1, '/corporate/rfp/create/description', true);
      } else if (key.startsWith('scope')) {
        onHandleStepChange(2, '/corporate/rfp/create/scope', true);
      }
      return false;
    }
  }
  return true;
};

export const copyTemplateSectionData = ({ sectionName, templateValue, proposalValue, proposalFileUploads, fileLimit = 5 }) => {
  const templateSection = templateValue[sectionName]?.[0];
  const proposalSection = proposalValue[sectionName]?.[0];

  if (!templateSection || !proposalSection) return;

  if (templateSection.additional_docs && proposalSection.additional_docs) {
    const clonedDocs = structuredClone(templateSection.additional_docs);
    const existingUploads = proposalFileUploads?.length || 0;
    const totalFiles = clonedDocs.length + existingUploads;

    if (totalFiles > fileLimit) {
      const maxAllowed = fileLimit - existingUploads;
      proposalSection.additional_docs = clonedDocs.slice(0, maxAllowed);
    } else {
      proposalSection.additional_docs = clonedDocs;
    }
  }

  if (templateSection.additional_information?.comment !== undefined) {
    proposalSection.additional_information.comment = templateSection.additional_information.comment;
  }
};
